import _ from "lodash";

export const renewThresholdDays = 90;

export const jpOemFeatures = "JpOem";

export const globalStellarOemSupportYears = 5;

export const millisecondsPerDay = 86400000;

export const LicenseTypes = {
  odcNode: 1,
  stellarKioskEdition: 12,
  stellarOemEdition: 13,
  elementOne: 14,
  stellarIcsEdition: 19,
  txonePIStd: 20,
  txonePIPro: 21,
  safePort: 22,
};

export function getLicenseFlags(license) {
  const features = _.get(license, "features", []);
  const isJpOem = Array.isArray(features) && features.includes(jpOemFeatures);
  const isStellarOem = license.licenseTypeId === LicenseTypes.stellarOemEdition;
  return { isJpOem, isStellarOem };
}

export const getLicenseStatus = (status) => {
  switch (status) {
    case "ACT":
      return "Activated";
    case "EXP":
      return "Expired";
    case "RVK":
      return "Revoked";
    default:
      return "Unknown";
  }
};

export const getLicenseStatusColor = (license) => {
  const status = typeof license === "object" ? license.status : license;
  const { isJpOem, isStellarOem } =
    typeof license === "object"
      ? getLicenseFlags(license)
      : { isJpOem: false, isStellarOem: false };
  const hasValidStart = typeof license === "object" && !!license.validStart;

  if (isStellarOem && !isJpOem && hasValidStart) {
    return "#3FD3BD";
  }

  switch (status) {
    case "Activated":
      return "#3FD3BD";
    case "Expired":
      return "#DE0B15";
    default:
      return "#B5B5B5";
  }
};

export const getLicenseProvider = (licenseKey) => {
  // eslint-disable-next-line quotes, prefer-regex-literals
  const re = new RegExp(`^\\w{2}-\\w{4}-\\w{5}-\\w{5}-\\w{5}-\\w{5}-\\w{5}$`);
  if (re.exec(licenseKey)) {
    return "Trend Micro";
  }
  return "TXOne";
};

export const isEdgeSN = (productSerialNumber) => {
  // eslint-disable-next-line quotes, prefer-regex-literals
  const edgeSNRegex = new RegExp("^(tx|tm|sn)(g|f|p|m|l)[0-9]{10,11}$", "i");
  return edgeSNRegex.test(productSerialNumber);
};

export const isAc = (licenseKey) => {
  // format: XX-XXXX-XXXXX-XXXXX-XXXXX-XXXXX-XXXXX
  const pattern =
    /^[A-Z]{2}-[A-Z0-9]{4}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}$/;
  return pattern.test(licenseKey);
};
